import { useMemo } from "react";
import { useScanBalance } from "@/hooks/useScanBalance";
import { deriveFeatures, type TierFeatures } from "@/lib/featureAccess";

/**
 * Convenience hook — wraps useScanBalance and returns the derived
 * per-tier feature flags. UI components should prefer this over
 * inspecting `subscription_tier` directly.
 */
export function useTierFeatures(): { features: TierFeatures; loading: boolean } {
  const { balance, loading } = useScanBalance();
  const features = useMemo(() => deriveFeatures(balance), [balance]);
  return { features, loading };
}